import * as t from 'io-ts';

import {makeEnumRuntimeType} from './apiTypes';
import {parseCalendarBehaviors, RCalendarBehaviors} from './calendarBehaviorsModel';
import {ConferenceTypesEnum} from './conferenceModel';

/*
 * Runtime type.
 */

export enum CalendarTeammateAccessRolesEnum {
  NONE = 'none',
  FREE_BUSY = 'free-busy',
  READER = 'reader',
  INHERIT = 'inherit',
}

export enum CalendarProviderTypesEnum {
  GOOGLE = 'google',
  OFFICE365 = 'office365',
  FRONT = 'front', // Not yet used.
}

export const RCalendarDirty = t.readonly(
  t.type({
    id: t.Integer,
    name: t.string,
    organizerAddress: t.union([t.string, t.undefined]),
    isPrimaryForOrganizer: t.boolean,
    teammateAccessRole: makeEnumRuntimeType(CalendarTeammateAccessRolesEnum),
    behaviors: RCalendarBehaviors,
    supportedProviderConferenceTypes: t.readonlyArray(makeEnumRuntimeType(ConferenceTypesEnum)),
    provider: makeEnumRuntimeType(CalendarProviderTypesEnum),
    updatedAt: t.Integer,
  }),
  'calendar',
);

/*
 * Type.
 */

export interface CalendarModel extends t.TypeOf<typeof RCalendarDirty> {}
export const RCalendar = t.clean<CalendarModel>(RCalendarDirty as any);

/*
 * IO methods.
 */

export function parseCalendar(src: any): CalendarModel {
  return {
    id: src.id,
    name: src.name,
    organizerAddress: src.organizer_address,
    isPrimaryForOrganizer: Boolean(src.primary_for_organizer),
    teammateAccessRole: src.teammate_access_role || CalendarTeammateAccessRolesEnum.NONE,
    behaviors: parseCalendarBehaviors(src),
    supportedProviderConferenceTypes: src.supported_provider_conference_types || [],
    provider: src.provider,
    updatedAt: src.updated_at,
  };
}

export function parseCalendarFromCalendarVersion(src: any): CalendarModel {
  return parseCalendar(src.calendar);
}
